/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CalendarEventTypeDto } from './calendarEventTypeDto';
import { CalendarEventPersonDto } from './calendarEventPersonDto';


export interface CalendarEventDto { 
    /**
     * Id del evento; en ocurrencias de recurrentes es \"<id>-<yyyy-MM-dd>\"
     */
    id: string;
    title: string;
    /**
     * yyyy-MM-dd si allDay; si no, fecha-hora ISO
     */
    start: string;
    /**
     * Último día del evento, inclusivo (mismo formato que start)
     */
    end?: string | null;
    allDay: boolean;
    /**
     * true si abarca más de un día
     */
    multiDay: boolean;
    description?: string | null;
    url?: string | null;
    /**
     * Regla RRULE del evento original (p. ej. \"FREQ=YEARLY\"); null si no es recurrente
     */
    rrule?: string | null;
    /**
     * Recurrencia legible (\"Cada año\", \"Cada mes\", \"Cada día\"); null si no es recurrente
     */
    recurrence?: string | null;
    type?: CalendarEventTypeDto;
    person?: CalendarEventPersonDto;
}

